import ItemDetailsView from './itemDetailsView';
export default ItemDetailsView